import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding Recap #44: Dipping my toes in AR.js",
  "description": "",
  "published": "2017-08-28T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-recap-44-dipping-toes-arjs/swizec/7759"],
  "categories": "Livecoding, Technical",
  "hero": "./img/AR.js-data-images-HIRO.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Usually shorter than 500 words. Often with pictures. Livecoding happens almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{` on multiple channels. You should follow `}<a parentName="em" {...{
          "href": "https://www.youtube.com/TheSwizec"
        }}>{`My Youtube`}</a>{` channel to catch me live.`}</em></p>
    <lite-youtube {...{
      "videoid": "N6PvDbyvj48",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`This Sunday, we dipped our toes in `}<a parentName="p" {...{
        "href": "https://github.com/jeromeetienne/AR.js"
      }}>{`AR.js`}</a>{`. We didn't get very far with anything real, but fun was had and things were learned.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/TGatk"
        }}></a></p>
    </blockquote>
    <p>{`AR.js is an open source library by `}<a parentName="p" {...{
        "href": "https://twitter.com/jerome_etienne"
      }}>{`Jerome Etienne`}</a>{` that promises to bring `}<em parentName="p">{`"Efficient Augmented Reality for the Web - 60fps on mobile!"`}</em>{`. And it did. Right after I updated my phone to a beta version of iOS11.`}</p>
    <p>{`Why iOS11?`}</p>
    <p>{`Because `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Augmented_reality"
      }}>{`augmented reality`}</a>{` requires access to your camera. To get access to your camera, AR.js uses `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/WebRTC"
      }}>{`WebRTC`}</a>{`. iOS doesn't support WebRTC in any browser until iOS11, which is meant to come out in the next 3 months.`}</p>
    <p>{`You can get the beta version until it's ready. So I did. Now I can AR 😁 AR.js in the browser, ARKit in native. Gonna have to play with that, too.`}</p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/IOS_11"
      }}>{`iOS11`}</a>{` looks great btw! My iPhone 5SE is a little small for the new fluffy design, but I can appreciate that things are easier to see. Does that mean I'm getting old? 🤔`}</p>
    <h2 {...{
      "id": "heres-what-we-did-to-get-a-basic-demo-running"
    }}>{`Here's what we did to get a basic demo running`}</h2>
    <p>{`We used `}<inlineCode parentName="p">{`create-react-app`}</inlineCode>{` to bootstrap an app. This proved more trouble than it was worth because AR.js doesn't work well with `}<inlineCode parentName="p">{`import`}</inlineCode>{` or `}<inlineCode parentName="p">{`require()`}</inlineCode>{` statements. There's been some work to modularize it, but it hasn't landed yet.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`not that i know of, i do <script>. there is a npm contrib, but im not sure how it helps - `}<a parentName="p" {...{
          "href": "https://t.co/cvZkRE3G94"
        }}>{`https://t.co/cvZkRE3G94`}</a></p>{`— Jerome Etienne #ARjs (@jerome_etienne) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/jerome_etienne/status/901932703070736384"
      }}>{`August 27, 2017`}</a></blockquote>
    <p>{`To get around this, we imported AR.js and `}<a parentName="p" {...{
        "href": "https://aframe.io/"
      }}>{`aframe`}</a>{` as `}<inlineCode parentName="p">{`<script>`}</inlineCode>{` tags in `}<inlineCode parentName="p">{`public/index.html`}</inlineCode>{`. This works well enough, but discards all the optimizations Webpack can do for us.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<!-- public/index.html -->
<script src="https://aframe.io/releases/0.6.1/aframe.min.js"></script>
<script src="https://jeromeetienne.github.io/AR.js/aframe/build/aframe-ar.js"></script>
<script src="%PUBLIC_URL%/aframe-minecraft.min.js"></script>
<title>React App</title>
`}</code></pre>
    <p><inlineCode parentName="p">{`aframe`}</inlineCode>{` gives us WebVR support. I think it creates special HTML elements we can use to build VR and AR scenes. Not sure if they count as web components or not.`}</p>
    <p><inlineCode parentName="p">{`AR.js`}</inlineCode>{` gives us… I'm still not sure where aframe ends and AR starts. But all the demo code we used comes from the AR.js project, so I'm sure it's doing a lot :)`}</p>
    <p><inlineCode parentName="p">{`aframe-minecraft`}</inlineCode>{` is a demo of a dancing minecraft figure that Jerome uses in some of his videos. We aaaalmost got it working.`}</p>
    <p>{`We render the scene in `}<inlineCode parentName="p">{`src/App.js`}</inlineCode>{` using strange HTML elements I have never seen before.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { Scene, Entity } from 'aframe-react';

class App extends Component {
    render() {
        return (
            <div class="App">
                <scene artoolkit="{{sourceType:" 'webcam',="" trackingmethod:="" 'best'}}="">

                    <a-anchor hit-testing-enabled="true">
                        <a-entity minecraft="" minecraft-head-anim="yes" minecraft-body-anim="hiwave" material="opacity: 0.5">
                        <a-box position="0 0 0.5" material="opacity: 0.5;"></a-box>
                    </a-entity></a-anchor>
                    <a-camera-static preset="hiro">
                </a-camera-static></scene>
            </div>
        );
    }
}
`}</code></pre>
    <p><inlineCode parentName="p">{`App`}</inlineCode>{` is a React component that renders stuff. We'll add more functionality next Sunday.`}</p>
    <p>{`Inside the render function, we use a combination of `}<inlineCode parentName="p">{`aframe-react`}</inlineCode>{`, which is a thing wrapper on Aframe, and custom HTML elements coming from, I guess, AR.js.`}</p>
    <p><inlineCode parentName="p">{`<Scene>`}</inlineCode>{` creates a new WebAR/WebVR scene. `}<inlineCode parentName="p">{`a-entity`}</inlineCode>{` is some sort of AR entity, whatever that means. In this case, a waving Minecraft figure that is supposed to be colorful and fun, but is instead pure black.`}</p>
    <p>{`Now that I think of it, we're probably missing texture files 🤔`}</p>
    <p><inlineCode parentName="p">{`a-box`}</inlineCode>{` creates a white semi transparent box. For some reason, this was necessary to make the Minecraft figure visible. I don't know why… maybe something to do with those textures.`}</p>
    <p><inlineCode parentName="p">{`a-camera-static`}</inlineCode>{` renders a full screen webcam view using the `}<inlineCode parentName="p">{`"hiro"`}</inlineCode>{` image as an AR marker.`}</p>
    <p>{`AR.js is a marker-based augmented reality engine, which means it needs a recognizable image to attach itself to the real world. This means you can't render your stuff on top of any random object the camera sees. You need a specific marker.`}</p>
    <p>{`Like this →`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "611px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/957fb590e3f9aa42178811c99bf3e352/a9121/AR.js-data-images-HIRO.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "86.54708520179372%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'346\\'%20viewBox=\\'0%200%20400%20346\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M38%20162v142h283V20H38v142m71%201v70h141V92H109v71m6%2038v25h10v-23h19v23h11v-51h-11v19h-18l-1-10v-9h-10v26m48-21v5h12v-10h-12v5m55%208c-14%206-16%2027-4%2036%2017%2013%2039-9%2028-28-5-8-16-12-24-8m-55%2019v20h12v-40h-12v20m19%200v19h10v-12l1-12%203-3%205-3c2%200%203-3%203-8%200-2-4-1-8%201-3%202-3%202-3%200-1-2-2-2-6-2h-5v20m41-11c-8%204-9%2017-1%2021%201%201%203%202%204%201h3c6-2%208-12%204-19l-7-4-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/957fb590e3f9aa42178811c99bf3e352/ca0a1/AR.js-data-images-HIRO.webp 223w", "/static/957fb590e3f9aa42178811c99bf3e352/75680/AR.js-data-images-HIRO.webp 445w", "/static/957fb590e3f9aa42178811c99bf3e352/ef8bf/AR.js-data-images-HIRO.webp 611w"],
              "sizes": "(max-width: 611px) 100vw, 611px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/957fb590e3f9aa42178811c99bf3e352/853b2/AR.js-data-images-HIRO.jpg 223w", "/static/957fb590e3f9aa42178811c99bf3e352/0a4fe/AR.js-data-images-HIRO.jpg 445w", "/static/957fb590e3f9aa42178811c99bf3e352/a9121/AR.js-data-images-HIRO.jpg 611w"],
              "sizes": "(max-width: 611px) 100vw, 611px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/957fb590e3f9aa42178811c99bf3e352/a9121/AR.js-data-images-HIRO.jpg",
              "alt": "AR js data images HIRO",
              "title": "AR js data images HIRO",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`The experiment `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/ar-js-experiment"
      }}>{`code is on Github`}</a>{`.`}</p>
    <h2 {...{
      "id": "heres-what-we-learned-about-arjs"
    }}>{`Here's what we learned about AR.js`}</h2>
    <p>{`AR.js is great, but it's early days for WebAR and augmented reality on the web. The experience was hacky and cool.`}</p>
    <p>{`You need markers, which limits usability. We can potentially improve this with on-the-spot deep learning that turns recognized objects into markers on the fly.`}</p>
    <p>{`You need a desktop browser, which doesn't need AR because why would it. Are you going to move your laptop around to look at augmented reality? Prob not.`}</p>
    <p>{`You need either an Android phone or iOS11. In a few months, everybody's phone is going to support AR.js. This is huge.`}</p>
    <p>{`WebRTC requires https. This makes development annoying because `}<inlineCode parentName="p">{`localhost`}</inlineCode>{` doesn't have https, so you have to deploy on a real server if you want to test on your phone.`}</p>
    <p>{`5/7 would hack again.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      